// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\ndiv[id^=\"+-\"] {\n  color: #3F51B5;\n  font-weight: 500;\n}", ""]);
// Exports
module.exports = exports;
